import React from 'react'
import PropTypes from 'prop-types'

import './CriticalErrorComponent.scss'

class CriticalErrorComponent extends React.Component {
  componentWillUnmount() {
    const { resetCriticalError } = this.props

    if (resetCriticalError) {
      resetCriticalError()
    }
  }

  render() {
    const { message, site } = this.props

    return (
      <div className="critical-error-component">
        <div className="image-wrapper">
          <img
            src={site.custom_logo_url || '/files/sitelogo.png'}
            alt={site.site_name}
          />
        </div>
        <h2>Something went wrong</h2>
        <p>{message}</p>
      </div>
    )
  }
}

CriticalErrorComponent.propTypes = {
  message: PropTypes.string,
  site: PropTypes.object,
  resetCriticalError: PropTypes.func,
}

export default CriticalErrorComponent
